import { pass, fail, skip } from "../buildResult";
import { defineTest } from "../defineTest";
import {
  getPatientSummaryMetrics,
  isPatientSummaryEmpty,
} from "../helper/patientFields";

export default defineTest(
  "patient_summary_present",
  "Patient summary",
  ({ patient }) => {
    if (!patient?.patient_id) return skip("No patient record");

    if (isPatientSummaryEmpty(patient.patient_summary)) {
      return fail(
        "Patient summary is missing",
        "patient.patient_summary is null, empty, or has no content in postgres"
      );
    }

    const { label } = getPatientSummaryMetrics(patient.patient_summary);
    return pass(`Patient summary present (${label})`);
  }
);
